import apiClient, { type PagedResponse } from '../client'
import type {
  BuildSettlementRequest,
  SettlementListItemResponse,
  SettlementDetailResponse,
  SettlementPreviewResponse,
  ShipmentForSettlementResponse,
  PendingSettlementListItemResponse,
} from '../models/response'

const BASE_PATH = '/settlements'

export const settlementsService = {
  async getAll(params?: { page?: number; pageSize?: number; search?: string }): Promise<PagedResponse<SettlementListItemResponse>> {
    return apiClient.get<PagedResponse<SettlementListItemResponse>>(BASE_PATH, params)
  },

  async getPending(params?: { page?: number; pageSize?: number; search?: string }): Promise<PagedResponse<PendingSettlementListItemResponse>> {
    return apiClient.get<PagedResponse<PendingSettlementListItemResponse>>(`${BASE_PATH}/pending`, params)
  },

  async getById(id: string): Promise<SettlementDetailResponse> {
    return apiClient.get<SettlementDetailResponse>(`${BASE_PATH}/${id}`)
  },

  async create(data: FormData): Promise<SettlementDetailResponse> {
    return apiClient.postForm<SettlementDetailResponse>(BASE_PATH, data)
  },

  async lookup(batchCode: string): Promise<ShipmentForSettlementResponse> {
    return apiClient.get<ShipmentForSettlementResponse>(`${BASE_PATH}/lookup/${encodeURIComponent(batchCode)}`)
  },

  async reject(shipmentRecordId: string, reason: string): Promise<boolean> {
    return apiClient.post<boolean>(`${BASE_PATH}/reject`, { shipmentRecordId, reason })
  },

  getDocumentUrl(settlementId: string, documentId: string): string {
    return apiClient.buildUrl(`${BASE_PATH}/${settlementId}/documents/${documentId}/file`)
  },

  async preview(
    shipmentRecordId: string,
    data: BuildSettlementRequest,
  ): Promise<SettlementPreviewResponse> {
    return apiClient.post<SettlementPreviewResponse, BuildSettlementRequest>(
      `${BASE_PATH}/${shipmentRecordId}/preview`,
      data,
    )
  },

  async build(
    shipmentRecordId: string,
    data: BuildSettlementRequest,
  ): Promise<SettlementPreviewResponse> {
    return apiClient.post<SettlementPreviewResponse, BuildSettlementRequest>(
      `${BASE_PATH}/${shipmentRecordId}/build`,
      data,
    )
  },
}
